import React, { useState, useEffect } from "react";
import logo from "../Assets/logo.png";
import { NavLink, useLocation, useNavigate, Link } from "react-router-dom";
import Image from "react-bootstrap/Image";
import { Container, Navbar, Nav, NavDropdown, Row, Col, } from "react-bootstrap";
import service1 from "../Assets/services/service-1.png"
import service2 from "../Assets/services/service-2.png"
import service3 from "../Assets/services/service-3.png"
import service4 from "../Assets/services/service-4.png"
import service5 from "../Assets/services/service-5.png"
import blog from "../Assets/blog.png"

const blogs = [
    {
        date: "5 Apr 2026",
        title: "Blog Title Lorem ipsum lorem eu it gosk sdf ase",
        image: blog,
    },
    {
        date: "2 Apr 2026",
        title: "Blog Title Lorem ipsum lorem eu it gosk sdf ase",
        image: blog,
    },
    {
        date: "1 Apr 2026",
        title: "Blog Title Lorem ipsum lorem eu it gosk sdf ase",
        image: blog,
    },
];

function NavBar() {
    const [expand, updateExpanded] = useState(false);
    const [navColour, updateNavbar] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    // Highlight Services menu when active
    const isParentActive = ["/qa_testing", "/offshore_team", "/mobile_application", "/custom_software", "/devops_cloud"].includes(location.pathname);;

    // Sticky Navbar on Scroll
    useEffect(() => {
        const scrollHandler = () => {
            if (window.scrollY >= 20) {
                updateNavbar(true);
            } else {
                updateNavbar(false);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        return () => window.removeEventListener("scroll", scrollHandler);
    }, []);

    // Detect desktop view
    const isDesktop = () => window.innerWidth >= 992;

    const handleMouseEnter = () => {
        if (isDesktop()) setShowDropdown(true);
    };

    const handleMouseLeave = () => {
        if (isDesktop()) setShowDropdown(false);
    };

    const handleClose = () => {
        updateExpanded(false);
        setShowDropdown(false);
    };

    return (
        <Navbar
            expanded={expand}
            fixed="top"
            expand="lg"
            className={`bg-white pb-0 ${navColour ? "sticky" : ""}`}
        >
            <Container>
                {/* Logo */}
                <Navbar.Brand as={Link} to="/" className="navbar-brand">
                    <Image src={logo} className="img-fluid logo" alt="brand" />
                </Navbar.Brand>

                {/* Mobile Toggle */}
                <Navbar.Toggle
                    aria-controls="responsive-navbar-nav"
                    onClick={() =>
                        updateExpanded(expand ? false : "expanded")
                    }
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </Navbar.Toggle>

                <Navbar.Collapse
                    id="responsive-navbar-nav"
                    className="flex-grow-0 text-uppercase"
                >
                    <Nav className="ms-auto align-items-center">
                        {/* Services Mega Menu */}
                        <NavDropdown
                            id="nav-dropdown"
                            show={showDropdown}
                            renderMenuOnMount
                            className={isParentActive ? "active" : ""}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            title={
                                <span
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate("/service");
                                        handleClose();
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    Services
                                </span>
                            }
                        >
                            <Container className="mega-menu p-4">
                                <Row>
                                    {/* Services Section */}
                                    <Col lg={8}>
                                        <Nav className="flex-column services-nav">
                                            <Row>
                                                <Col md={6}>
                                                    <Nav.Link
                                                        as={Link}
                                                        to="/custom_software"
                                                        className="service-item d-flex align-items-start gap-3 bg-hover"
                                                        onClick={handleClose}
                                                    >
                                                        <Image src={service1} className='w-34' />
                                                        <div>
                                                            <h5>Custom Software Development</h5>
                                                            <p>From initial concepts to enterprise products, we build robust, scalable applications with Ruby on Rails expertise.</p>
                                                        </div>
                                                    </Nav.Link>

                                                    <Nav.Link
                                                        as={Link}
                                                        to="/mobile_application"
                                                        className="service-item d-flex align-items-start gap-3 bg-hover"
                                                        onClick={handleClose}
                                                    >
                                                        <Image src={service2} className='w-34' />
                                                        <div>
                                                            <h5>Mobile Application Development</h5>
                                                            <p>We design fast, intuitive mobile experiences that perform seamlessly across all devices to keep users engaged.</p>
                                                        </div>
                                                    </Nav.Link>

                                                    <Nav.Link
                                                        as={Link}
                                                        to="/devops_cloud"
                                                        className="service-item d-flex align-items-start gap-3 bg-hover"
                                                        onClick={handleClose}
                                                    >
                                                        <Image src={service3} className='w-34' />
                                                        <div>
                                                            <h5>DevOps & Cloud Solutions</h5>
                                                            <p>Accelerate your releases and improve system stability through modern cloud infrastructure and automated DevOps workflows.</p>
                                                        </div>
                                                    </Nav.Link>
                                                </Col>

                                                <Col md={6}>
                                                    <Nav.Link
                                                        as={Link}
                                                        to="/qa_testing"
                                                        className="service-item d-flex align-items-start gap-3 bg-hover"
                                                        onClick={handleClose}
                                                    >
                                                        <Image src={service4} className='w-34' />
                                                        <div>
                                                            <h5>Quality Assurance & Testing</h5>
                                                            <p>Our rigorous testing processes ensure your software performs exactly as expected, delivering high-quality results every time.</p>
                                                        </div>
                                                    </Nav.Link>

                                                    <Nav.Link
                                                        as={Link}
                                                        to="/offshore_team"
                                                        className="service-item d-flex align-items-start gap-3 bg-hover"
                                                        onClick={handleClose}
                                                    >
                                                        <Image src={service5} className='w-34' />
                                                        <div>
                                                            <h5>Offshore Team Setup</h5>
                                                            <p>Scale your workforce with elite talent that integrates into your workflow to maintain high development momentum.</p>
                                                        </div>
                                                    </Nav.Link>
                                                </Col>
                                            </Row>
                                        </Nav>
                                    </Col>

                                    {/* Latest Blogs Section */}
                                    <Col lg={4}>
                                        <div className="blogs-card bg-gradient-1 p-3 border">
                                            <h6 className="blogs-title">LATEST BLOGS</h6>

                                            {blogs.map((blog, index) => (
                                                <div className="blog-item d-flex gap-2 pb-2 text-transform-none" key={index}>
                                                    <Image src={blog.image} className="w-25" />
                                                    <div>
                                                        <small>{blog.date}</small>
                                                        <p>{blog.title}</p>
                                                    </div>
                                                </div>
                                            ))}

                                            <Link
                                                to="/blogs"
                                                className="btn btn-outline-dark rounded-pill text-uppercase mt-3"
                                                onClick={handleClose}
                                            >
                                                VIEW ALL BLOGS
                                            </Link>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </NavDropdown>

                        {/* Other Navigation Links */}
                        <Nav.Item>
                            <NavLink to="/blogs" onClick={handleClose}>
                                Insights
                            </NavLink>
                        </Nav.Item>

                        <Nav.Item>
                            <NavLink to="/about" onClick={handleClose}>
                                About
                            </NavLink>
                        </Nav.Item>

                        <Nav.Item>
                            <NavLink to="/careers" onClick={handleClose}>
                                Careers
                            </NavLink>
                        </Nav.Item>
                    </Nav>
                </Navbar.Collapse>

                {/* Contact Button */}
                <Nav.Item>
                    <NavLink
                        to="/contact"
                        className="btn btn-outline-dark rounded-pill text-uppercase ms-3"
                        onClick={handleClose}
                    >
                        Contact Us
                    </NavLink>
                </Nav.Item>
            </Container>

            <div className="mob-overlay"></div>
        </Navbar>
    );
}

export default NavBar;